import { render, staticRenderFns } from "./PelatihanReport.vue?vue&type=template&id=7b73bed5"
import script from "./PelatihanReport.vue?vue&type=script&lang=js"
export * from "./PelatihanReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports